<template>
    <div class="component">
        <h1>Einstellungen</h1>
        <TabSelector :tabs
                     @changeTab="handleChangeTab"/>
        <pre>
            {{ syncedHash }}
        </pre>
        <pre>
            {{ remoteHash }}
        </pre>
    </div>
</template>
<script>
import TabSelector from "@/components/parts/TabSelector.vue";

export default {

    name      : "Settings",
    components: { TabSelector },

    data()
    {
        return {
            syncedConfig   : false,
            syncedHash     : false,
            remoteConfig   : false,
            remoteHash     : false,
            dbSyncReady    : false,
            remoteSyncReady: false,
            tabs           : [
                {
                    id   : 'general',
                    label: 'Einstellungen'
                },
                {
                    id   : 'users',
                    label: 'Benutzerkonten'
                },
                {
                    id   : 'params',
                    label: 'Parameter'
                },
                {
                    id   : 'ui',
                    label: 'App'
                }
            ]
        }
    },

    mounted()
    {

        let message = {
            method: 'uhc.getConfig',
            plain : false
        }

        this.$core.getDatabase()
            .readStorage( 'remoteConfigBlob' )
            .then( remoteConfigBlob =>
            {

                this.syncedConfig = JSON.parse( remoteConfigBlob )
                this.syncedHash = remoteConfigBlob.hash()

            } )
            .catch( () =>
            {
                this.syncedConfig = false
                this.syncedHash = false
            } )
            .finally( () =>
            {
                this.dbSyncReady = true
            } )


        this.$core.getWebsockets()
            .request( message )
            .then( response =>
            {

                this.remoteConfig = JSON.parse( response )

                console.log( 'DBG', this.remoteConfig )

                this.remoteHash = response.hash()
                this.$core.getDatabase()
                    .writeStorage( 'remoteConfigBlob', response )
                this.remoteSyncReady = true

            } )
    },

    methods: {
        handleChangeTab( event )
        {
            console.log( 'DBG', event )
        }
    }

}

</script>